export default "__VITE_ASSET__DNxUHvJR__"